// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__CScaF","emails":"CreateEditClinics_emails__3RQe3","emailTagLabel":"CreateEditClinics_emailTagLabel__3m-vo"};